const STORAGE_PREFIX = 'buildbee_default_bid_'

export function getDefaultBidUid(orgUid) {
  if (!orgUid) return ''
  try {
    return localStorage.getItem(STORAGE_PREFIX + String(orgUid)) || ''
  } catch (e) {
    return ''
  }
}

export function setDefaultBidUid(orgUid, bidUid) {
  if (!orgUid) return
  try {
    const key = STORAGE_PREFIX + String(orgUid)
    if (bidUid) {
      localStorage.setItem(key, String(bidUid))
    } else {
      localStorage.removeItem(key)
    }
  } catch (e) {
    /* ignore */
  }
}

export function isDefaultBidUid(orgUid, bidUid) {
  if (!orgUid || !bidUid) return false
  return String(getDefaultBidUid(orgUid)) === String(bidUid)
}

/** 超时清缓存时保留默认标段等偏好，避免下次登录丢失 */
export function clearLocalStorageKeepPrefs() {
  const keep = {}
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (
        key &&
        (key.indexOf(STORAGE_PREFIX) === 0 ||
          key === 'userName' ||
          key === 'passwd')
      ) {
        keep[key] = localStorage.getItem(key)
      }
    }
    localStorage.clear()
    Object.keys(keep).forEach((key) => {
      if (keep[key] != null) localStorage.setItem(key, keep[key])
    })
  } catch (e) {
    try {
      localStorage.clear()
    } catch (err) {
      /* ignore */
    }
  }
}
